export const API_SEND_REQUEST_START = 'API_SEND_REQUEST_START';
export const API_SEND_REQUEST_SUCCESS = 'API_SEND_REQUEST_SUCCESS';
export const API_SEND_REQUEST_ERROR = 'API_SEND_REQUEST_ERROR';



// WEBPACK FOOTER //
// ./src/modules/api/constants.ts